import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import { useNavigate } from "react-router-dom";
import { FaTrash, FaTimes, FaUpload, FaPlus } from "react-icons/fa"; // Import icons from react-icons
import axios from "axios";
import { Base_url_bbbs, Base_url_imggg, Base_url_live } from "../config";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import Modal from 'react-modal';


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '90%',
  },
};



let CreditCardApply = () => {
  const [finedata, setFineData] = useState({});

  const [modeldata, setmodeldata] = useState([]);
  const [modeldatakey, setmodeldatakey] = useState(0);
  const [modeldatakey2, setmodeldatakey2] = useState(0);



  useEffect(() => {
    Startone()
  }, [])


  let Startone = async () => {

    let apicall = await axios({
      method: "get",
      url: Base_url_live + "/transactionstatus/ccapplyget",
    })
      .then((dat) => {

        console.log(dat.data.data, "Jsson data data data data");

        setFineData(dat.data.data)
        if (dat.status === true) {


        } else {

        }
      })
      .catch((ee) => {
        console.log(ee, "eeeeeeeeeeee");
      });
  }


  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }




  const Savedata = async () => {


    console.log(finedata, "finedata");


    if (finedata.hasOwnProperty("default")) {
      delete finedata.default;
    }




    let apicall = await axios({
      method: "post",
      url: Base_url_live + "/transactionstatus/ccapplys",
      data: {
        data: finedata,
      },
    })
      .then((dat) => {
        alert("Update Successful");
        console.log(dat.data, "Jsson");
        if (dat.status === true) {



        } else {

        }
      })
      .catch((ee) => {
        console.log(ee, "eeeeeeeeeeee");
      });
  };

  const navigate = useNavigate();

  const handleEdit = (category, field, value) => {

    setFineData((prevData) => ({
      ...prevData,
      [category]: {
        ...prevData[category],
        [field]: value,
      },
    }));
  };

  const handleCategoryEdit = (category, index, field, value) => {

    if (index === null) {

      setFineData((prevData) => ({
        ...prevData,
        [category]: {
          ...prevData.All,
          img: value, // Replace with your desired image URL
        },
      }));

    } else {
      setFineData((prevData) => ({
        ...prevData,
        [category]: {
          ...prevData[category],
          category: prevData[category].category.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
          ),
        },
      }));
    }
  };

  const handleImageUpload = async (category, index, field, event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        // Create a FormData object to send the file
        const formData = new FormData();
        formData.append('file', file); // Append the file to the FormData object

        // Call the fileUpload API to upload the image to S3
        const uploadResponse = await axios({
          method: "post",
          url: 'https://web.xopay.in/bbps/api' + "/transactionstatus/fileUpload", // Replace with your actual API endpoint
          data: formData, // Send the FormData object as the request body
          headers: {
            'Content-Type': 'multipart/form-data', // Set the content type for file uploads
          },
        });

        if (uploadResponse.data.status && uploadResponse.data.url) {
          const s3Url = uploadResponse.data.url;

          // Update the state with the S3 URL
          if (field.startsWith("benifits")) {
            const benefitIndex = parseInt(field.match(/\[(\d+)\]/)[1], 10);
            setFineData((prevData) => ({
              ...prevData,
              [category]: {
                ...prevData[category],
                category: prevData[category].category.map((item, i) =>
                  i === index
                    ? {
                      ...item,
                      benifits: item.benifits.map((benefit, bi) =>
                        bi === benefitIndex
                          ? { ...benefit, img: s3Url } // Use the S3 URL
                          : benefit
                      ),
                    }
                    : item
                ),
              },
            }));
          } else {
            handleCategoryEdit(category, index, field, s3Url); // Use the S3 URL
          }
        } else {
          console.error("Failed to upload image to S3");
        }
      } catch (error) {
        console.error("Error uploading image to S3:", error);
      }
    }
  };

  const removeImage = (category, index, field) => {
    if (field.startsWith("benifits")) {
      // Extract the benefit index from the field name
      const benefitIndex = parseInt(field.match(/\[(\d+)\]/)[1], 10);

      // Update the specific benefit's image to an empty string
      setFineData((prevData) => ({
        ...prevData,
        [category]: {
          ...prevData[category],
          category: prevData[category].category.map((item, i) =>
            i === index
              ? {
                ...item,
                benifits: item.benifits.map((benefit, bi) =>
                  bi === benefitIndex ? { ...benefit, img: "" } : benefit
                ),
              }
              : item
          ),
        },
      }));
    } else {
      // Handle regular image removal
      handleCategoryEdit(category, index, field, "");
    }
  };

  const removeCategory = (category, index) => {
    if (window.confirm("Do you want to delete this category?")) {
      setFineData((prevData) => ({
        ...prevData,
        [category]: {
          ...prevData[category],
          category: prevData[category].category.filter((_, i) => i !== index),
        },
      }));
    }
  };

  const removeCard = (category) => {
    if (window.confirm("Do you want to delete this card?")) {
      setFineData((prevData) => {
        const newData = { ...prevData };
        delete newData[category];
        return newData;
      });
    }
  };

  const addCategory = (category) => {
    setFineData((prevData) => ({
      ...prevData,
      [category]: {
        ...prevData[category],
        category: [
          ...prevData[category].category,
          {
            img: "",
            name: "",
            des: "",
            tittle: "",
            bankname: "",
            bankimg: "",
            key: [""], // Default input for features
            benifits: [{ img: "", tit: "" }], // Default input for benefits
            card_fee: [""], // Default input for fee
          },
        ],
      },
    }));
  };

  const addCard = () => {
    const newCardName = prompt("Enter the name of the new card:");
    if (newCardName) {
      setFineData((prevData) => ({
        [newCardName]: {
          name: newCardName,
          img: "",
          category: [
            {
              img: "",
              name: "",
              des: "",
              tittle: "",
              bankname: "",
              bankimg: "",
              key: [""], // Default input for features
              benifits: [{ img: "", tit: "" }], // Default input for benefits
              card_fee: [""], // Default input for fee
            },
          ],
        },
        ...prevData, // Add new card at the top
      }));
    }
  };



  const addBenefit = (category, index) => {
    setFineData((prevData) => ({
      ...prevData,
      [category]: {
        ...prevData[category],
        category: prevData[category].category.map((item, i) =>
          i === index
            ? {
              ...item,
              benifits: [...item.benifits, { img: "", tit: "" }],
            }
            : item
        ),
      },
    }));
  };

  const addFee = (category, index) => {
    setFineData((prevData) => ({
      ...prevData,
      [category]: {
        ...prevData[category],
        category: prevData[category].category.map((item, i) =>
          i === index
            ? {
              ...item,
              card_fee: [...item.card_fee, ""],
            }
            : item
        ),
      },
    }));
  };

  const addFeature = (category, index) => {
    setFineData((prevData) => ({
      ...prevData,
      [category]: {
        ...prevData[category],
        category: prevData[category].category.map((item, i) =>
          i === index
            ? {
              ...item,
              key: [...item.key, ""],
            }
            : item
        ),
      },
    }));
  };

  const removeInput = (category, index, field, subIndex) => {
    setFineData((prevData) => ({
      ...prevData,
      [category]: {
        ...prevData[category],
        category: prevData[category].category.map((item, i) =>
          i === index
            ? {
              ...item,
              [field]: item[field].filter((_, idx) => idx !== subIndex),
            }
            : item
        ),
      },
    }));
  };

  useEffect(() => {
    Start();
    User();
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let User = async () => { };

  let clickeddd = async (key, index) => {

  }

  return (
    <div className="container-fluid">
      <div className="row">
        <Header />
        <div
          className="col-10"
          style={{ overflowY: "scroll", height: "100vh", scrollbarWidth: "none" }}
        >
          <div className="p-4">
            <div className="" style={{ display: 'flex', justifyContent: "space-between" }} >
              <h2 onClick={() => console.log(finedata, "finedatafinedatafinedata")}>
                Fine Data Table
              </h2>
              <div >
                <button className="btn btn-primary mb-3" onClick={Savedata}>
                  Save
                </button>
              </div>
            </div>

            <button className="btn btn-primary mb-3" onClick={addCard}>
              Add Card
            </button>
            {Object.keys(finedata).map((key) => (
              <div
                key={key}
                className="card mb-4 p-3 position-relative"
                style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
              >

                <div className="row mb-4">
                  <div className="col-3" >
                    <input
                      type="text"
                      value={finedata[key].name}
                      onChange={(e) => handleEdit(key, "name", e.target.value)}
                      className="form-control "
                    />
                  </div>



                  <div className="col-1">
                    {finedata[key].img ? (
                      <div className="position-relative" style={{ width: "35px" }}>
                        <img
                          src={Base_url_imggg + finedata[key].img}
                          alt={finedata[key].name}
                          className="img-fluid rounded"
                          style={{ width: 20, height: "auto" }}
                        />
                        <div
                          className="position-absolute top-0 end-0   bg-danger rounded-circle"
                          style={{ cursor: "pointer", padding: 5 }}
                          onClick={() => handleEdit(key, "img", "")}
                        >
                          <FaTimes style={{ width: 10, height: 10, display: 'block', margin: 'auto' }} className="text-white" />
                        </div>
                      </div>
                    ) : (
                      <label className="btn btn-outline-secondary">
                        <FaUpload />
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleImageUpload(key, null, "img", e)}
                          // onChange={(e) => {
                          //   const file = e.target.files[0];
                          //   if (file) {
                          //     const imageUrl = URL.createObjectURL(file); // Generate preview URL

                          //     handleEdit(key, "img", imageUrl); // Update state with preview URL   
                          //   }
                          // }}
                          style={{ display: "none" }}
                        />
                      </label>
                    )}
                  </div>

                  <div className="col-2" >
                    <button

                      className="btn btn-success "
                      onClick={() => addCategory(key)}
                    >
                      Add Category
                    </button>
                  </div>

                  <div className="col-3" >
                    <button
                      className="btn btn-danger   "
                      onClick={() => removeCard(key)}
                    >
                      <FaTrash />
                    </button>
                  </div>




                </div>

                <div className="row" style={{ gap: 10 }} >
                  {finedata[key].category?.map((item, index) => (
                    <div key={index} class="card col-3" >
                      {item.img ? (
                        <div className="position-relative"  >
                          <img
                            src={Base_url_imggg + item.img}
                            alt="Category"
                            className="img-fluid rounded"
                            style={{ width: "100%", height: "auto" }}
                          />
                          <div
                            className="position-absolute top-0 end-0 p-1 bg-danger rounded-circle"
                            style={{ cursor: "pointer" }}
                            onClick={() => removeImage(key, index, "img")}
                          >
                            <FaTimes className="text-white" />
                          </div>
                        </div>
                      ) : (
                        <label className="btn btn-outline-secondary">
                          <FaUpload />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageUpload(key, index, "img", e)}
                            style={{ display: "none" }}
                          />
                        </label>
                      )}
                      <div class="card-body">
                        <h5 class="card-title">{item.name}</h5>
                        <div onClick={() => {
                          setmodeldatakey(key)
                          setmodeldatakey2(index)
                          setmodeldata(item)
                          openModal()
                        }} class="btn btn-primary">Edit</div>
                      </div>
                    </div>
                  ))}
                </div>





                {/* <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Image And link</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Title</th>
                      <th>Bank Name</th>
                      <th>Fee</th>
                      <th>Benefits</th>
                      <th>Features</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {finedata[key].category?.map((item, index) => (
                      <tr key={index}>
                        <td> 
                          {item.img ? (
                            <div className="position-relative" style={{ width: "50px" }}>
                              <img
                                src={Base_url_imggg + item.img}
                                alt="Category"
                                className="img-fluid rounded"
                                style={{ width: "100%", height: "auto" }}
                              />
                              <div
                                className="position-absolute top-0 end-0 p-1 bg-danger rounded-circle"
                                style={{ cursor: "pointer" }}
                                onClick={() => removeImage(key, index, "img")}
                              >
                                <FaTimes className="text-white" />
                              </div>
                            </div>
                          ) : (
                            <label className="btn btn-outline-secondary">
                              <FaUpload />
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleImageUpload(key, index, "img", e)}
                                style={{ display: "none" }}
                              />
                            </label>
                          )}

                          <input
                            type="text"
                            value={item.link}
                            onChange={(e) => handleCategoryEdit(key, index, "link", e.target.value)}
                            className="form-control"
                          />

                        </td>
                        <td>
                          <input
                            type="text"
                            value={item.name}
                            onChange={(e) => handleCategoryEdit(key, index, "name", e.target.value)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={item.des}
                            onChange={(e) => handleCategoryEdit(key, index, "des", e.target.value)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={item.tittle}
                            onChange={(e) => handleCategoryEdit(key, index, "tittle", e.target.value)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={item.bankname}
                            onChange={(e) => handleCategoryEdit(key, index, "bankname", e.target.value)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          {item.card_fee?.map((fee, feeIndex) => (
                            <div key={feeIndex} className="mb-2 position-relative">
                              <input
                                type="text"
                                value={fee}
                                onChange={(e) => {
                                  const newFees = [...item.card_fee];
                                  newFees[feeIndex] = e.target.value;
                                  handleCategoryEdit(key, index, "card_fee", newFees);
                                }}
                                className="form-control"
                              />
                              <FaTimes
                                className="position-absolute top-0 end-0 mt-1 me-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => removeInput(key, index, "card_fee", feeIndex)}
                              />
                            </div>
                          ))}
                          <FaPlus
                            className="mt-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => addFee(key, index)}
                          />
                        </td>
                        <td>
                          {item.benifits?.map((benefit, benefitIndex) => (
                            <div key={benefitIndex} className="mb-3">
                              <div className="d-flex align-items-center">
                                {benefit.img ? (
                                  <div className="position-relative me-3">
                                    <img
                                      src={Base_url_imggg + benefit.img}
                                      alt="Benefit"
                                      className="img-fluid rounded"
                                      style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                    />
                                    <div
                                      className="position-absolute top-0 end-0 p-1 bg-danger rounded-circle"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        removeImage(key, index, `benifits[${benefitIndex}].img`)
                                      }
                                    >
                                      <FaTimes className="text-white" />
                                    </div>
                                  </div>
                                ) : (
                                  <label className="btn btn-outline-secondary">
                                    <FaUpload />
                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={(e) =>
                                        handleImageUpload(key, index, `benifits[${benefitIndex}].img`, e)
                                      }
                                      style={{ display: "none" }}
                                    />
                                  </label>
                                )}
                                <input
                                  type="text"
                                  value={benefit.tit}
                                  onChange={(e) => {
                                    const newBenefits = [...item.benifits];
                                    newBenefits[benefitIndex] = {
                                      ...newBenefits[benefitIndex],
                                      tit: e.target.value,
                                    };
                                    handleCategoryEdit(key, index, "benifits", newBenefits);
                                  }}
                                  className="form-control ms-2"
                                  placeholder="Benefit Title"
                                />
                                <FaTimes
                                  className="ms-2"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => removeInput(key, index, "benifits", benefitIndex)}
                                />
                              </div>
                            </div>
                          ))}
                          <FaPlus
                            className="mt-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => addBenefit(key, index)}
                          />
                        </td>
                        <td>
                          {item.key?.map((k, i) => (
                            <div key={i} className="mb-2 position-relative">
                              <input
                                type="text"
                                value={k}
                                onChange={(e) => {
                                  const newKeys = [...item.key];
                                  newKeys[i] = e.target.value;
                                  handleCategoryEdit(key, index, "key", newKeys);
                                }}
                                className="form-control"
                              />
                              <FaTimes
                                className="position-absolute top-0 end-0 mt-1 me-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => removeInput(key, index, "key", i)}
                              />
                            </div>
                          ))}
                          <FaPlus
                            className="mt-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => addFeature(key, index)}
                          />
                        </td>
                        <td>
                          <button
                            className="btn btn-danger"
                            onClick={() => removeCategory(key, index)}
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table> */}


              </div>
            ))}
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="d-flex justify-content-between mb-2">
          <button className="btn btn-primary mb-3" onClick={Savedata}>
            Save
          </button>
          <div style={{ fontSize: 20 }} onClick={closeModal}>X</div>
        </div>

        {/* {modeldata[modeldatakey]?.category?.map((item, index) => ( */}
        <>
          <div className="row" >
            <div className="col-3" >

              <p>Category Image </p>

              {finedata[modeldatakey]?.category[modeldatakey2]?.img ? (
                <div className="position-relative" style={{ width: "200px" }}>
                  <img
                    src={Base_url_imggg + finedata[modeldatakey]?.category[modeldatakey2]?.img}
                    alt="Category"
                    className="img-fluid rounded"
                    style={{ width: "100%", height: "auto" }}
                  />
                  <div
                    className="position-absolute top-0 end-0 p-1 bg-danger rounded-circle"
                    style={{ cursor: "pointer" }}
                    onClick={() => removeImage(modeldatakey, modeldatakey2, "img")}
                  >
                    <FaTimes className="text-white" />
                  </div>
                </div>
              ) : (
                <label className="btn btn-outline-secondary">
                  <FaUpload />
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(modeldatakey, modeldatakey2, "img", e)}
                    style={{ display: "none" }}
                  />
                </label>
              )}


            </div>
            <div className="col-3" >
              <p>Category Redirect Link</p>
              <textarea
                type="text"
                value={finedata[modeldatakey]?.category[modeldatakey2]?.link}
                onChange={(e) => handleCategoryEdit(modeldatakey, modeldatakey2, "link", e.target.value)}
                className="form-control"
              />
            </div>
            <div className="col-3" >
              <p>Category Name</p>
              <input
                type="text"
                value={finedata[modeldatakey]?.category[modeldatakey2]?.name}
                onChange={(e) => handleCategoryEdit(modeldatakey, modeldatakey2, "name", e.target.value)}
                className="form-control"
              />
            </div>
            <div className="col-3" >
              <p>Description</p>
              <input
                type="text"
                value={finedata[modeldatakey]?.category[modeldatakey2]?.des}
                onChange={(e) => handleCategoryEdit(modeldatakey, modeldatakey2, "des", e.target.value)}
                className="form-control"
              />
            </div>

          </div>

          <div className="row mt-5" >
            <div className="col-3" >
              <p>Tittle</p>
              <input
                type="text"
                value={finedata[modeldatakey]?.category[modeldatakey2]?.tittle}
                onChange={(e) => handleCategoryEdit(modeldatakey, modeldatakey2, "tittle", e.target.value)}
                className="form-control"
              />
            </div>
            <div className="col-3" >
              <p>Bank Name	</p>
              <input
                type="text"
                value={finedata[modeldatakey]?.category[modeldatakey2]?.bankname}
                onChange={(e) => handleCategoryEdit(modeldatakey, modeldatakey2, "bankname", e.target.value)}
                className="form-control"
              />
            </div>

            <div className="col-6" >
              <p>Fee</p>
              {finedata[modeldatakey]?.category[modeldatakey2]?.card_fee?.map((fee, feeIndex) => (
                <div key={feeIndex} className="mb-2 position-relative">
                  <textarea
                    type="text"
                    value={fee}
                    onChange={(e) => {
                      const newFees = [...finedata[modeldatakey]?.category[modeldatakey2]?.card_fee];
                      newFees[feeIndex] = e.target.value;
                      handleCategoryEdit(modeldatakey, modeldatakey2, "card_fee", newFees);
                    }}
                    className="form-control"
                  />
                  <FaTimes
                    className="position-absolute top-0 end-0 mt-1 me-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => removeInput(modeldatakey, modeldatakey2, "card_fee", feeIndex)}
                  />
                </div>
              ))}
              <FaPlus
                className="mt-2"
                style={{ cursor: "pointer" }}
                onClick={() => addFee(modeldatakey, modeldatakey2)}
              />

            </div>
          </div>

          <div className="row mt-5" >
            <div className="col-6" >
              <p>Benefits</p>
              {finedata[modeldatakey]?.category[modeldatakey2]?.benifits?.map((benefit, benefitIndex) => (
                <div key={benefitIndex} className="mb-3">
                  <div className="d-flex align-items-center">
                    {benefit.img ? (
                      <div className="position-relative me-3">
                        <img
                          src={Base_url_imggg + benefit.img}
                          alt="Benefit"
                          className="img-fluid rounded"
                          style={{ width: "50px", height: "50px", objectFit: "cover" }}
                        />
                        <div
                          className="position-absolute top-0 end-0 p-1 bg-danger rounded-circle"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            removeImage(modeldatakey, modeldatakey2, `benifits[${benefitIndex}].img`)
                          }
                        >
                          <FaTimes className="text-white" />
                        </div>
                      </div>
                    ) : (
                      <label className="btn btn-outline-secondary">
                        <FaUpload />
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            handleImageUpload(modeldatakey, modeldatakey2, `benifits[${benefitIndex}].img`, e)
                          }
                          style={{ display: "none" }}
                        />
                      </label>
                    )}
                    <input
                      type="text"
                      value={benefit.tit}
                      onChange={(e) => {
                        const newBenefits = [...modeldata.benifits];
                        newBenefits[benefitIndex] = {
                          ...newBenefits[benefitIndex],
                          tit: e.target.value,
                        };
                        handleCategoryEdit(modeldatakey, modeldatakey2, "benifits", newBenefits);
                      }}
                      className="form-control ms-2"
                      placeholder="Benefit Title"
                    />
                    <FaTimes
                      className="ms-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeInput(modeldatakey, modeldatakey2, "benifits", benefitIndex)}
                    />
                  </div>
                </div>
              ))}
              <FaPlus
                className="mt-2"
                style={{ cursor: "pointer" }}
                onClick={() => addBenefit(modeldatakey, modeldatakey2)}
              />
            </div>
            <div className="col-5" >
              <p>Features</p>
              {finedata[modeldatakey]?.category[modeldatakey2]?.key?.map((k, i) => (
                <div key={i} className="mb-2 position-relative">
                  <textarea
                    type="text"
                    value={k}
                    onChange={(e) => {
                      const newKeys = [...finedata[modeldatakey]?.category[modeldatakey2]?.key];
                      newKeys[i] = e.target.value;
                      handleCategoryEdit(modeldatakey, modeldatakey2, "key", newKeys);
                    }}
                    className="form-control"
                  />
                  <FaTimes
                    className="position-absolute top-0 end-0 mt-1 me-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => removeInput(modeldatakey, modeldatakey2, "key", i)}
                  />
                </div>
              ))}
              <FaPlus
                className="mt-2"
                style={{ cursor: "pointer" }}
                onClick={() => addFeature(modeldatakey, modeldatakey2)}
              />
            </div>
            <div className="col-1" >
              <button
                className="btn btn-danger"
                onClick={() => removeCategory(modeldatakey, modeldatakey2)}
              >
                <FaTrash />
              </button>
            </div>
          </div>



        </>

 
      </Modal>
    </div>
  );
};

export default CreditCardApply;